import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=a47957e6&scoped=true&"
import script from "./profile.vue?vue&type=script&lang=js&"
export * from "./profile.vue?vue&type=script&lang=js&"
import style0 from "./profile.vue?vue&type=style&index=0&id=a47957e6&prod&scoped=true&lang=css&"
import style1 from "./profile.vue?vue&type=style&index=1&id=a47957e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47957e6",
  null
  
)

export default component.exports